import Store from '@/store'
import { isEmpty } from 'lodash-es'

export default async function(to, from, next) {
  // in the case where the user reloads the app after being logged in... make sure we fetch some basic information
  const accountInfo = Store.getters['user/accountInfo']

  await Store.dispatch('user/startRefreshTimer')
  // fetch account info if it's not present
  if (isEmpty(accountInfo.accountEmailAddress)) {
    await Store.dispatch('user/getMyDetails')
  }

  const companyInfo = Store.getters['user/accountInfo'].company

  // fetch company info if it's not present
  if (companyInfo && isEmpty(companyInfo.companyKey) && Store.getters['user/isShipper']) {
    console.info('No company found for current user')
    console.info('User is of type shipper... redirecting to registration')
    next({ name: 'shipper-registration-companyinfo', params: { canGoBack: false } })
  }

  if (Store.getters['user/isShipper']) {
    Store.dispatch('company/getDetails').then(() => {
      Store.dispatch('company/getUsers')
    })
  }

  next()
}
